import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  filter(event) {
    const query = event.currentTarget.value.toLowerCase().trim();
    const containerId = event.currentTarget.dataset.filterDivId;
    const container = document.getElementById(containerId);
    if (!container) return;

    const items = container.querySelectorAll("label");
    items.forEach((label) => {
      const text = label.textContent.toLowerCase();
      const wrapper = label.parentElement;
      wrapper.style.display = text.includes(query) ? "" : "none";
    });
  }
}
